export const SCAN = 'scan';
export const WAP = 'wap';
export const CODE = 'code';
export const WEB = 'web';
export const MP = 'mp';
export const FAMILY = 'family';
export const CHECKOUT = 'checkout';
export const STRIPE_WECHAT_SCAN = 'wechat_scan';
export const STRIPE_ALIPAY = 'alipay';
export const NHP_ALIPAY_WEB = 'alipay_web';
export const NHP_WECHAT_WAP = 'wechat_wap';
export const NHP_ALIPAY_WAP = 'alipay_wap';
export const NHP_WECHAT_SCAN = 'wechat_scan';
export const NHP_WECHAT_MP = 'wechat_mp';
export const AL = 'AL';
export const WX = 'WX';
export const STRIPE = 'STRIPE';
export const NHP = 'NHP';
export const SDL = 'SDL';
export const FAMILY_CHANNEL = 'FAMILY';
export const CMB = 'CMB';
export const PAY_METHODS = {
  SCAN,
  WAP,
  CODE,
  WEB,
  MP,
  FAMILY,
  CHECKOUT,
  STRIPE_WECHAT_SCAN,
  STRIPE_ALIPAY,
  /**
   * @DESC nihaopay支付方式
   * alipay_web (支付宝电脑版网页),
   * wechat_wap（微信H5）,
   * alipay_wap（支付宝手机版）,
   * wechat_scan （微信扫码）,
   * wechat_mp(微信浏览器内支付),
   * unionpay_scan,unionpay_wap,unionpay_web（这几个都是银联）
   */
  NHP_ALIPAY_WEB,
  NHP_WECHAT_WAP,
  NHP_ALIPAY_WAP,
  NHP_WECHAT_SCAN,
  NHP_WECHAT_MP
};
export const PAY_CHANNELS = {
  AL,
  WX,
  STRIPE,
  NHP,
  SDL,
  FAMILY: FAMILY_CHANNEL,
  CMB
};
export const WX_OPEN_ID_KEY = 'HSYLC2021_WXPAY_OID';
